import FunctionalList from '../../../components/GenericTable/FunctionalList'
import { Order } from '../../../../core/models/entities/Order'
import { PageQuery } from '../../../../utils/models/pageQuery'
import { Organization } from '../../../../core/models/entities/Organization'
import { QueryChanger } from '../../../shared/hooks/usePageQuery'
import { useFunctionalListOrdersViewModel } from '../vmHooks/useFunctionalListOrdersViewModel'
import { Profile } from '../../../../core/models/entities/Profile'

interface WrapperProps {
  profile: Profile,
  onSelectOrder: (order: Order) => void,
  lastPage: number,
  query: PageQuery,
  customers: Organization[],
  isPageLoading: boolean,
  // keepPreviousData indicators from useAllOrders: while isFetching &&
  // isPreviousData the shown rows belong to the previous query and
  // FunctionalList dims them (no full spinner).
  isFetching?: boolean,
  isPreviousData?: boolean,
  // Optional paginator hover-prefetch (forwarded to FunctionalList).
  onPrefetchPage?: (pageIndex: number) => void | Promise<void>,
  orders?: Order[],
  vendors: Organization[] | undefined,
  queryChanger: QueryChanger
  onRejectionNote: (order: Order) => void
  // Admin-only cancel of Awaiting payment rows; undefined = no button rendered.
  onCancelOrder?: (order: Order) => void
}

export function OrderListWrapper({ profile, lastPage, query, customers, isPageLoading, isFetching, isPreviousData, onPrefetchPage, orders, vendors, queryChanger, onRejectionNote: onRejectionNote, onSelectOrder, onCancelOrder }: WrapperProps) {
  const vm = useFunctionalListOrdersViewModel(profile, lastPage, query, customers, isPageLoading, vendors, queryChanger, onRejectionNote, onSelectOrder, orders, isFetching, isPreviousData, onPrefetchPage, onCancelOrder)
  return <FunctionalList<Order> {...vm} />
}

